/** DOM/SVG helpers for scene object nodes (drag, resize, path sync). */

import type { SceneObject } from "./SceneHost";
import { svgGroupTransform } from "./transform/rotate";
import { applyWidgetContentScale } from "./render/htmlLayerObject";

export type ObjectBounds = { x: number; y: number; w: number; h: number };

export function isSvgGroup(el: Element): el is SVGGElement {
  return el instanceof SVGGElement;
}

export function applySceneObjectTransform(el: Element, obj: SceneObject): void {
  if (isSvgGroup(el)) {
    el.setAttribute("transform", svgGroupTransform(obj));
    return;
  }
  if (el instanceof HTMLElement) {
    el.style.left = `${obj.x}px`;
    el.style.top = `${obj.y}px`;
  }
}

export function setObjectTransform(el: Element, x: number, y: number): void {
  if (isSvgGroup(el)) {
    el.setAttribute("transform", `translate(${x},${y})`);
    return;
  }
  if (el instanceof HTMLElement) {
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
  }
}

export function applyObjectBounds(el: Element, b: ObjectBounds): void {
  if (isSvgGroup(el)) {
    el.setAttribute("transform", `translate(${b.x},${b.y})`);
    // Размер тянется прямо во время движения ручки, поэтому всё, что внутри
    // группы и живёт своими width/height, нужно обновить здесь же.
    //
    // Картинка этого не получала: её рисует <image>, а правило знало только
    // про foreignObject — и при растягивании за угол картинка стояла на месте,
    // а подскакивала к новому размеру только после отпускания. Соседняя
    // фигура при этом тянулась нормально, поэтому выглядело как поломка
    // именно у картинок.
    for (const child of Array.from(el.children)) {
      const tag = child.tagName.toLowerCase();
      if (tag !== "foreignobject" && tag !== "image" && tag !== "rect") continue;
      // Рамка объекта — своя, её размеры задаёт сам отрисовщик.
      if (tag === "rect" && !child.classList.contains("wb-scene-image__bg")) continue;
      child.setAttribute("width", String(b.w));
      child.setAttribute("height", String(b.h));
    }
    return;
  }
  if (el instanceof HTMLElement) {
    el.style.left = `${b.x}px`;
    el.style.top = `${b.y}px`;
    el.style.width = `${b.w}px`;
    el.style.height = `${b.h}px`;
    // Виджет: буквы и кнопки растут вместе с рамкой прямо во время растягивания.
    applyWidgetContentScale(el, b.w, b.h);
  }
}
